import { lang } from "../../i18n/i18n";

/** Les 32 nations de l'OTAN (code ISO 3166-1 alpha-3), proposées pour un ordre de bataille ami. Facultative, la
 *  nation est affichée et gardée dans le document ; le moteur ne s'en sert pas. */
export const NATO_NATIONS: { code: string; fr: string; en: string }[] = [
  { code: "ALB", fr: "Albanie", en: "Albania" },
  { code: "DEU", fr: "Allemagne", en: "Germany" },
  { code: "BEL", fr: "Belgique", en: "Belgium" },
  { code: "BGR", fr: "Bulgarie", en: "Bulgaria" },
  { code: "CAN", fr: "Canada", en: "Canada" },
  { code: "HRV", fr: "Croatie", en: "Croatia" },
  { code: "DNK", fr: "Danemark", en: "Denmark" },
  { code: "ESP", fr: "Espagne", en: "Spain" },
  { code: "EST", fr: "Estonie", en: "Estonia" },
  { code: "USA", fr: "États-Unis", en: "United States" },
  { code: "FIN", fr: "Finlande", en: "Finland" },
  { code: "FRA", fr: "France", en: "France" },
  { code: "GRC", fr: "Grèce", en: "Greece" },
  { code: "HUN", fr: "Hongrie", en: "Hungary" },
  { code: "ISL", fr: "Islande", en: "Iceland" },
  { code: "ITA", fr: "Italie", en: "Italy" },
  { code: "LVA", fr: "Lettonie", en: "Latvia" },
  { code: "LTU", fr: "Lituanie", en: "Lithuania" },
  { code: "LUX", fr: "Luxembourg", en: "Luxembourg" },
  { code: "MKD", fr: "Macédoine du Nord", en: "North Macedonia" },
  { code: "MNE", fr: "Monténégro", en: "Montenegro" },
  { code: "NOR", fr: "Norvège", en: "Norway" },
  { code: "NLD", fr: "Pays-Bas", en: "Netherlands" },
  { code: "POL", fr: "Pologne", en: "Poland" },
  { code: "PRT", fr: "Portugal", en: "Portugal" },
  { code: "ROU", fr: "Roumanie", en: "Romania" },
  { code: "GBR", fr: "Royaume-Uni", en: "United Kingdom" },
  { code: "SVK", fr: "Slovaquie", en: "Slovakia" },
  { code: "SVN", fr: "Slovénie", en: "Slovenia" },
  { code: "SWE", fr: "Suède", en: "Sweden" },
  { code: "CZE", fr: "Tchéquie", en: "Czechia" },
  { code: "TUR", fr: "Türkiye", en: "Türkiye" },
];

/** Nations dans l'ordre alphabétique de la langue de l'interface. */
export function nations(): { code: string; name: string }[] {
  const english = lang() === "en";
  return NATO_NATIONS.map((n) => ({ code: n.code, name: english ? n.en : n.fr })).sort((a, b) =>
    a.name.localeCompare(b.name, english ? "en" : "fr"),
  );
}

/** Nom d'une nation (son code s'il n'est pas de l'OTAN). */
export function nationName(code: string | null | undefined): string | null {
  if (!code) return null;
  const found = NATO_NATIONS.find((n) => n.code === code);
  return found ? (lang() === "en" ? found.en : found.fr) : code;
}
